import { Box, Text } from 'wix-style-react';
import * as React from 'react';
import { translate } from 'react-i18next';
export var CustomerPhone = translate()(function (_a) {
    var phoneNumber = _a.phoneNumber, t = _a.t;
    return phoneNumber ? (React.createElement(Box, { paddingBottom: "4px" },
        React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-phone-number" }, t('invoice-view:price-quote.view.customer.phone-title', {
            phoneNumber: phoneNumber,
        })))) : null;
});
//# sourceMappingURL=CustomerPhone.js.map